/**
 * MultiRW Store
 * MultiRW 상태 관리
 *
 * @since 2018-06-20
 * @author mk.ko
 */

import { menuPathToInfo, menuCodeToPath } from '~/utils/multirw'

export const state = () => ({
  isNewWindow: false,

  isExistChkInWork: false,
  thisMenuCode: 0,
  thisMenuPath: '',
  thisMenuPermission: 0, // 0: ReadOnly, 1: R/W
  // thisMenuDevice: '',
  // userInfo: {},

  isLock: false,
  isCheckIn: false,
  isReadOnly: true,
  IsCheckInBefore: false,
  lockUserInfo: {},
  lockMenuCode: 0,
  lockMenuSubCode: 0,
  lockMenuPath: '',

  isConfirmCheckOut: false,
  preventPageMoveReload: false,
  memoRouterPathCode: {}
})

export const mutations = {
  // setUserInfo (state, userInfo) {
  //   state.userInfo = userInfo
  // },
  setMenuInfo (state, menu) {
    state.thisMenuCode = menu.code
    state.thisMenuPath = menu.path
    state.thisMenuPermission = menu.permission
    // state.thisMenuDevice = menu.device
  },

  setLockState (state, { isLock, isCheckIn, lockUserInfo }) {
    state.isLock = Boolean(isLock)
    state.isCheckIn = Boolean(isCheckIn)
    state.isReadOnly = !state.isCheckIn
    state.lockUserInfo = (typeof lockUserInfo !== 'undefined') ? lockUserInfo : {}
  },

  setCheckInOut (state, { isLock, isCheckIn }) {
    state.isLock = isLock
    state.IsCheckInBefore = state.isCheckIn
    state.isCheckIn = isCheckIn
    state.isReadOnly = !state.isCheckIn
  },
  setExistChkInWork (state, { isExistChkWork, lockMenuCode, lockMenuSubCode, lockMenuPath }) {
    state.isExistChkInWork = isExistChkWork
    state.lockMenuCode = lockMenuCode
    state.lockMenuSubCode = lockMenuSubCode
    state.lockMenuPath = lockMenuPath
  },
  setConfirmDialog (state, isConfirmCheckOut) {
    state.isConfirmCheckOut = isConfirmCheckOut
  },

  setNewWindow (state, isNewWindow) {
    state.isNewWindow = isNewWindow
  },

  setPreventPageMoveReload (state, payload) {
    state.preventPageMoveReload = payload
  },

  setMemoRouterPathCode (state, { path, memo }) {
    state.memoRouterPathCode[path] = memo
  }
}

export const actions = {
  // // ui-data 사용하도록 변경
  // async setUserInfo ({ commit, rootGetters }) {
  //   // 추후: 임시 추후 로그인 ID 값을 state에 저장하는 방식으로 변경 필요 할 듯
  //   const authUser = rootGetters['common/authenticate/authUser']
  //   // const authUser = rootState.common.authenticate.authUser
  //   const { result } = await this.$axios.$get('/api/sm/admin/admin-status', {
  //     successAlert: false,
  //     loading: false
  //   }) // 전체 관리자 계정 검색
  //   const thisUser = result.find(row => row.admin_name === authUser.id) // 현재 접속 계정정보
  //   commit('setUserInfo', thisUser)
  // },

  // 미들웨어용 새 창 상태 정보
  async checkNewWindow ({ commit }, isNewWindow) {
    commit('setNewWindow', isNewWindow)
  },

  // 미들웨어용 페이지 이동에 따른 현재 페이지 상태 정보
  async setMenuInfo ({ commit, state, rootState }, routePath) {
    try {
      const menu = rootState.common.navigation.menu
      if (menu) {
        let menuPath = ''
        if (typeof state.memoRouterPathCode[routePath] !== 'undefined') {
          commit('setMenuInfo', state.memoRouterPathCode[routePath])
        } else {
          const {code: menuCode, admin_menu_role_type: menuPermission, device_menu_type: deviceMenuType} = menuPathToInfo(routePath, menu)
          menuPath = routePath

          const memo = {
            code: menuCode,
            path: menuPath,
            permission: menuPermission,
            device: deviceMenuType
          }

          commit('setMemoRouterPathCode', {
            path: routePath,
            memo
          })

          commit('setMenuInfo', memo)
        }
      }
    } catch (e) {
      this.$log('[MultiR/W Store GUI Error (setMenuInfo)]', e)
    }
  },

  // 미들웨어용 페이지 이동에 따른 현재 계정에 대한 체크인 상태 정보
  async checkExistChkInWork ({ commit, getters, rootGetters, rootState }) {
    const uiData = rootState.common.common.uiData
    const { result } = await this.$axios.$get('/api/cm/check-in', {
      params: {
        admin_id: uiData.user.adm_id
      },
      successAlert: false,
      loading: false,
      ignoreHaPrefix: true
    })

    let isExistChkWork = false
    let lockMenuCode = 0
    let lockMenuSubCode = 0
    let lockMenuPath = ''
    if (result.length > 0) {
      const lockMenuInfo = result[0]
      const menu = rootState.common.navigation.menu
      lockMenuCode = lockMenuInfo['menu_id']
      lockMenuSubCode = lockMenuInfo['sub_id']
      lockMenuPath = menuCodeToPath(lockMenuCode, menu)
      isExistChkWork = true
    }
    commit('setExistChkInWork', {
      isExistChkWork: isExistChkWork,
      lockMenuCode: lockMenuCode,
      lockMenuSubCode: lockMenuSubCode,
      lockMenuPath: lockMenuPath
    })
  },

  // 현재 페이지에 대한 체크인 정보
  async checkLockState ({ commit, rootGetters, rootState, getters }, { menuId, subId }) {
    const thisMenu = getters.thisMenu, // 현재 메뉴 정보
      uiData = rootState.common.common.uiData

    const res = await this.$axios.$get('/api/cm/check-in', {
      params: {
        admin_id: uiData.user.adm_id,
        menu_id: (typeof menuId === 'undefined') ? thisMenu.code : menuId,
        sub_id: subId
      },
      successAlert: false,
      loading: false,
      ignoreHaPrefix: true
    })

    if (res.result.length > 0) {
      const menuLockInfo = res.result[0]
      const lockUserInfo = {}
      lockUserInfo['admin_chk_in_dt'] = menuLockInfo['admin_chk_in_dt']

      if (menuLockInfo.admin_id === uiData.user.adm_id) {
        lockUserInfo['admin_id'] = uiData.user.adm_id
        lockUserInfo['admin_name'] = uiData.user.login_id

        commit('setLockState', { isLock: true, isCheckIn: true, lockUserInfo: lockUserInfo })
      } else if (Number(uiData.user.admin_type) === 3) { // TAMS, Super-Admin 권한
        // 전체 관리자 계정 검색
        const adminStatusRes = await this.$axios.$get('/api/sm/admin/admin-status', {
          params: {
            admin_id: menuLockInfo.admin_id
          },
          successAlert: false,
          loading: false
        })

        if (adminStatusRes.result.length > 0) {
          const adminUserInfo = adminStatusRes.result[0]

          lockUserInfo['admin_id'] = adminUserInfo['admin_id']
          lockUserInfo['admin_name'] = adminUserInfo['admin_login_uname']

          commit('setLockState', { isLock: true, lockUserInfo: lockUserInfo })
        }
      }
    } else {
      commit('setLockState', { isLock: false })
    }
    return res
  },

  async checkIn ({ commit, getters, rootState }, { menuId, subId }) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const thisMenu = getters.thisMenu, // 현재 메뉴 정보
        uiData = rootState.common.common.uiData

      res = await this.$axios.$post('/api/cm/check-in', {
        admin_id: uiData.user.adm_id,
        menu_id: (typeof menuId === 'undefined') ? thisMenu.code : menuId,
        sub_id: subId
      }, {
        successAlert: false,
        loading: false,
        ignoreHaPrefix: true
      })

      if (res.code === 'ok') {
        commit('setCheckInOut', {
          isLock: true,
          isCheckIn: true
        })
      } else {
        commit('setCheckInOut', {
          isLock: true,
          isCheckIn: false
        })
      }
    } catch (e) {
      commit('setCheckInOut', {
        isLock: true,
        isCheckIn: false
      })

      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  async checkOut ({ commit, getters, rootState }) {
    let res = {
      code: 'ok',
      result: {}
    }
    try {
      const uiData = rootState.common.common.uiData
      res = await this.$axios.$delete('/api/cm/check-in', {
        data: {admin_id: uiData.user.adm_id},
        successAlert: false,
        loading: false,
        ignoreHaPrefix: true
      })

      if (res.code === 'ok') {
        commit('setCheckInOut', {
          isLock: false,
          isCheckIn: false
        })
      } else {
        commit('setCheckInOut', {
          isLock: true,
          isCheckIn: false
        })
      }
    } catch (e) {
      commit('setCheckInOut', {
        isLock: true,
        isCheckIn: false
      })

      res.code = 'nok'
      res.result.msg = e.message
    }
    return res
  },
  setConfirmDialog ({ commit }, isConfirmCheckOut) {
    commit('setConfirmDialog', isConfirmCheckOut)
  }
}

export const getters = {
  thisMenu (state) {
    return {
      code: state.thisMenuCode,
      path: state.thisMenuPath
    }
  },
  // thisUser (state, getters, rootState, rootGetters) {
  //   return state.userInfo
  // },
  isExistChkInWork (state) {
    return state.isExistChkInWork
  },
  isLock (state) {
    return state.isLock
  },
  isCheckIn (state) {
    return state.isCheckIn
  },
  isReadOnly (state) {
    return state.isReadOnly
  },
  lockInfo (state) {
    return {
      userInfo: state.lockUserInfo,
      menuCode: state.lockMenuCode,
      menuSubCode: state.lockMenuSubCode,
      menuPath: state.lockMenuPath
    }
  },
  isConfirmCheckOut (state) {
    return state.isConfirmCheckOut
  },
  isNewWindow (state) {
    return state.isNewWindow
  },
  thisMenuInfo (state) {
    return {
      code: state.thisMenuCode,
      path: state.thisMenuPath,
      permission: state.thisMenuPermission
    }
  },
  // thisMenuSupportInfo (state) {
  //   return {
  //     device: state.thisMenuDevice
  //   }
  // },
  // 네비게이션용 가드 Multi R/W 작업 체커
  isMultiRWGuard (state, getters, rootState, rootGetters) {
    return state.isCheckIn || rootGetters['dashboard/dashboard/isChanged']
  }
}

export const strict = false
